import React, { useState } from 'react';
import Header from '../components/shared/Header';
import SearchField from './shared/SearchField';
import MapComponent from './MapComponent';
import ListingComponent from './ListingComponent';
import '../styles/global.css';
import '../styles/ListingScreen.css';

const steps = [
  { name: 'Select the location', link: 'listing', isActive: true },
  { name: 'Appointment Details', isActive: false },
  { name: 'Confirm Details', isActive: false }
];

const ListingScreen = () => {

  const [selectedLocation, setSelectedLocation] = useState(null);

  // Define the function 'handlePlaceSelected'
  const handlePlaceSelected = (place) => {
    // Update the selected location state when a place is selected
    setSelectedLocation({
      location: place.location,
      lat: place.lat,
      lng: place.lng
    });
  };
  return (
    <div className="main-container">
      <Header
        title="Book an Eye Test"
        steps={steps}
        subheading="SELECT THE LOCATION"
        pageinfo="Search for the nearest Optical Superstore near you."
      />
      <div className="sub-container">
        <SearchField onPlaceSelected={handlePlaceSelected} />
        <div className="listing-map-container">
          {/* Listing Section */}
          <div className="listing-container">
          {/* Pass the 'handlePlaceSelected' function to the ListingComponent */}
          <ListingComponent onSelectLocation={handlePlaceSelected} selectedLocation={selectedLocation} />
        </div>

          {/* Map Section */}
          <div className="map-container">
            <MapComponent location={selectedLocation} />
          </div>
        </div>
      </div>  
    </div>
  );
};

export default ListingScreen;